/*
*
* Script for megamenu
*
*/

export const megamenuInit = () => {
    const nav = document.querySelector(".header");

    if (!nav) return;
	
    const switchLinks = nav.querySelectorAll(".switch-link");
    switchLinks.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            
            const spanCircle = link.querySelector(".switch-link__circle");
            if (spanCircle) {
                if (spanCircle.classList.contains("switch-link__circle--right")) {
                    spanCircle.classList.remove("switch-link__circle--right");
                } else {
                    spanCircle.classList.add("switch-link__circle--right");
                }
            }
            
            setTimeout(() => {
                const href = link.getAttribute("href");
                const target = link.getAttribute("target");
                
                if (href) {
                    if (target === "_blank") {
                        window.open(href, "_blank");
                    } else {
                        window.location.href = href;
                    }
                }
            }, 500);
        });
    });

	const menuMobileBreakpoint = getComputedStyle(document.documentElement)
    .getPropertyValue("--breakpoint-menu-mobile")
    .trim();

	let mediaQuery = window.matchMedia(`(min-width: ${menuMobileBreakpoint})`);

	if (!mediaQuery.matches) return;


	const submenuWrap = nav.querySelectorAll(".megamenu-submenu-wrap");
	if (submenuWrap.length < 1) return;

	submenuWrap.forEach(wrap => {
		const subMenu = wrap.querySelector(" .sub-menu");
		if (!subMenu) return;


		const setOverflowClasses = () => {
			// Check if subMenu overflows submenuWrap
			const wrapRect = wrap.scrollHeight;
			const subMenuRect = subMenu.scrollHeight;
			const bodyContrast = document.body.classList.contains("contrast-mode");

			let wrapSpacing = 81;

			if( bodyContrast ) {
				wrapSpacing = 82;
			}

			if (subMenuRect > (wrapRect - wrapSpacing)) {
				wrap.classList.add("--overflows");
			} else {
				wrap.classList.remove("--overflows");
			}
			if( !wrap.classList.contains("--overflows") ) return;
			if (wrap.scrollTop === 0) {
				wrap.classList.add("--bottom");
				wrap.classList.remove("--top");
			} else if (wrap.scrollTop + wrap.clientHeight < wrap.scrollHeight - 2) {
				wrap.classList.add("--bottom");
				wrap.classList.add("--top");
			} else {
				wrap.classList.add("--top");
				wrap.classList.remove("--bottom");
			}
		}

		wrap.parentElement.addEventListener("mouseenter", setOverflowClasses);
		wrap.parentElement.addEventListener("focusin", setOverflowClasses);

		wrap.addEventListener("scroll", setOverflowClasses, { passive: true });
		setOverflowClasses();
	});

}